if($('.trng-prog-you').length){
    let btn = $('.js-full-trng');
    let trngContainer = $('.trng-prog-you__blocks');

    btn.on('click', function () {
        
        if(trngContainer.hasClass('_open')){
            trngContainer.removeClass('_open');
            btn.text('Посмотреть полный список программ');
        }else{
            trngContainer.addClass('_open');
            btn.text('Свернуть полный список программ');
        }
    });
}